import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { DEFAULT_COURSES_ROUTE, MASTER_COURSES_ROUTE } from '../../constants';
import { CourseFilterWrapper, FilterTabs, FilterItems } from './styled';

const CourseFilter = ({ children }) => {
    const styleProps = {};

    ['disabled'].forEach((style) => {
        if (style) {
            styleProps[style] = true;
        }
    });

    return (
        <CourseFilterWrapper {...styleProps}>
            <FilterTabs>
                <NavLink exact to={{ pathname: MASTER_COURSES_ROUTE }} >Curriculum</NavLink>
                <NavLink exact to={{ pathname: DEFAULT_COURSES_ROUTE }} >3P Courses</NavLink>
            </FilterTabs>
            <FilterItems>
                {children}
            </FilterItems>
        </CourseFilterWrapper>);
};

CourseFilter.propTypes = {
    children: PropTypes.node,
    disabled: PropTypes.bool
};

export default CourseFilter;



// WEBPACK FOOTER //
// ./app/components/course-filter/index.js